import { createSlice } from "@reduxjs/toolkit";

const PAPER_NAME_KEYS = [
  "paper_name",
  "test_name",
  "paperName",
  "testName",
  "exam_name",
];

export const pickPaperName = (source) => {
  if (!source || typeof source !== "object") return "";

  const readName = (record) => {
    if (!record || typeof record !== "object") return "";
    for (const key of PAPER_NAME_KEYS) {
      const value = record[key];
      if (typeof value === "string" && value.trim()) return value.trim();
    }
    return "";
  };

  return (
    readName(source) ||
    readName(source.student_summary) ||
    readName(source.data)
  );
};

const initialState = {
  testDate: "",
  paperId: "",
  paperName: "",
  plannerTestId: "",
  papers: {},
  expectedRank: "",
  allIndiaRank: "",
  singlePaper: {},
};

const parentTestSlice = createSlice({
  name: "parentTest",
  initialState,
  reducers: {
    setPaperId: (state, action) => {
      if (String(state.paperId ?? "") !== String(action.payload ?? "")) {
        state.paperName = "";
      }
      state.paperId = action.payload;
    },
    setPaperName: (state, action) => {
      state.paperName =
        typeof action.payload === "string" ? action.payload.trim() : "";
    },
    setPlannerTestId: (state, action) => {
      state.plannerTestId = action.payload;
    },
    setTestDate: (state, action) => {
      state.testDate = action.payload;
    },
    setPapers: (state, action) => {
      state.papers = action.payload;
    },

    setSinglePaper: (state, action) => {
      state.singlePaper = action.payload;
      const name = pickPaperName(action.payload);
      if (name) state.paperName = name;
    },
    setExpectedRank: (state, action) => {
      state.expectedRank = action.payload;
    },
    setAllIndiaRank: (state, action) => {
      state.allIndiaRank = action.payload;
    },
    setPlannerId: (state, action) => {
      state.plannerTestId = action.payload;
    },
  },
});

export const {
  setPaperId,
  setPaperName,
  setPlannerTestId,
  setTestDate,
  setPapers,
  setExpectedRank,
  setAllIndiaRank,
  setPlannerId,
  setSinglePaper,
} = parentTestSlice.actions;

export const parentTestReducer = parentTestSlice.reducer;
